module.exports = __webpack_public_path__ + "std/img/Backgorund.b087818.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/common/newregister/Backgorund.png
// module id = 7SER
// module chunks = 0